import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumb({ items }) {
  return (
    <nav data-testid="breadcrumb" aria-label="Breadcrumb" className="text-sm text-[#7C8CA0]">
      <ol className="flex items-center flex-wrap gap-1.5">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 hover:text-[#10B981] transition-colors">
            <Home size={13} /> Anasayfa
          </Link>
        </li>
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight size={12} className="text-[#D1D9E4]" />
            {it.to ? (
              <Link to={it.to} className="hover:text-[#10B981] transition-colors">{it.label}</Link>
            ) : (
              <span className="text-[#0E2B4F] font-medium">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
